import React, { FC, memo } from 'react';
import { makeStyles } from '@mui/styles';
import InputBase, { InputBaseProps } from '@mui/material/InputBase';
import classes from './formControl.module.scss';

type FormControlProps = {
  error?: boolean;
  errorMessage?: string;
} & InputBaseProps;

const inputStyles = (error: FormControlProps['error']) => {
  return {
    padding: '7.5px 10px',
    flex: 1,
    borderRadius: 4,
    border: error ? '1px solid' : 'none',
    borderColor: error ? '#FF7221' : '#E0E7E8',
    height: 34,
    background: '#F3F5F6',
    color: '#444A52',
    // '&:focus': {
    //   borderColor: Color.darkBlue,
    // },
    '&::placeholder': {
      color: '#CACED2',
      opacity: 1,
    },
    '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
  };
};

export const FormControl: FC<FormControlProps> = memo(
  ({ error, errorMessage, ...props }: FormControlProps) => {
    const useStyles = makeStyles({
      root: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 150,
        width: '100%',
        // height: props.multiline ? 'unset' : 36,
        boxSizing: 'border-box',
        // marginLeft: 25,
      },

      input: {
        fontSize: 16,
        flex: 1,
        display: 'flex',
        '& input': inputStyles(error),
        '& textarea': inputStyles(error),
      },
      error: {
        color: '#FF7221',
        fontSize: 14,
        marginTop: 3,
        minHeight: 12,
      },
    });

    const style = useStyles();

    return (
      <div className={classes.container}>
        <div className={style.root}>
          <InputBase {...props} className={style.input} />
        </div>
        <div className={classes.container__p}>
          <p className={style.error} />
        </div>
      </div>
    );
  },
);
